var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    viewBox: "0 0 13.435 12.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-3905.9-6264.349v3.846h3.523",
    transform: "translate(3905.903 6271.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-3902.379-6264.349v3.846h-3.523",
    transform: "translate(3914.314 6271.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-3905.9-6260.5v-3.845h3.523",
    transform: "translate(3905.903 6264.348)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-3902.379-6260.5v-3.845h-3.523",
    transform: "translate(3914.314 6264.348)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.4bbba98e85806004a3aa0f2a8e1259df.svg";
export { ForwardRef as ReactComponent };